module.exports = __webpack_public_path__ + "static/edu-29a7aad413fa28f3b85290fbcc42a788.jpg";